// NANP 10 位号码「单层格式化 input」共享逻辑（USPhoneInput / USFaxNumberInput）：
// input 里直接显示 (555) 123-4567，对外 onChange 仍抛纯数字，因此选区/光标与可见文字天然对齐。

export function buildNanpDisplayMask(digits: string): string {
    if (!digits.length) return '';
    if (digits.length > 7) {
        let out = '(';
        for (let i = 0; i < digits.length; i++) {
            if (i === 3) out += ') ';
            else if (i === 6) out += '-';
            out += digits[i];
        }
        return out;
    }
    let out = '';
    for (let i = 0; i < digits.length; i++) {
        if (i === 3) out += '-';
        out += digits[i];
    }
    return out;
}

export function countDigits(str: string): number {
    return (str.match(/\d/g) || []).length;
}

/** 格式化文本中第 n 个数字之后的光标位置（n<=0 → 0） */
export function caretPosAfterDigits(formatted: string, n: number): number {
    if (n <= 0) return 0;
    let seen = 0;
    for (let i = 0; i < formatted.length; i++) {
        if (formatted[i] >= '0' && formatted[i] <= '9') {
            seen += 1;
            if (seen === n) return i + 1;
        }
    }
    return formatted.length;
}

/**
 * 解析一次 change：剥掉格式字符取纯数字，并算出光标前的数字个数（用于重排后恢复光标）。
 * 退格/Delete 恰好只删掉格式字符时数字不变，重排后字符会被补回来导致「退格卡住」——
 * 此时改删相邻的那个数字。
 */
export function parseNanpChange(
    el: HTMLInputElement,
    inputType: string | undefined,
    prevDigits: string,
): { digits: string; digitsBefore: number } {
    const rawText = el.value;
    const caret = el.selectionStart ?? rawText.length;
    const rawDigits = rawText.replace(/\D/g, '');
    const caretDigitsRaw = countDigits(rawText.slice(0, caret));
    // 上限通常是 10 位；存量值本身超长（脏数据）时以其当前长度为上限——只许删、不许再增
    const overflow = rawDigits.length - Math.max(10, prevDigits.length);
    let digits: string;
    let digitsBefore: number;
    if (overflow > 0) {
        // 超过 10 位的插入：丢弃紧贴光标前的多余输入、保住原有尾部数字（还原 maxLength 的行为，
        // 否则满 10 位后在中间打字会不断挤掉末位）
        digitsBefore = Math.max(0, caretDigitsRaw - overflow);
        digits = rawDigits.slice(0, digitsBefore) + rawDigits.slice(caretDigitsRaw);
    } else {
        digits = rawDigits;
        digitsBefore = caretDigitsRaw;
    }

    if (digits === prevDigits) {
        if (inputType === 'deleteContentBackward' && digitsBefore > 0) {
            digits = digits.slice(0, digitsBefore - 1) + digits.slice(digitsBefore);
            digitsBefore -= 1;
        } else if (inputType === 'deleteContentForward' && digitsBefore < digits.length) {
            digits = digits.slice(0, digitsBefore) + digits.slice(digitsBefore + 1);
        }
    }
    return { digits, digitsBefore };
}
